export default "__VITE_ASSET__kjJL46Pj__"